/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HealthResponseBody
 */
export interface HealthResponseBody {
    /**
     * 
     * @type {string}
     * @memberof HealthResponseBody
     */
    commit: string;
    /**
     * 
     * @type {string}
     * @memberof HealthResponseBody
     */
    build: string;
    /**
     * 
     * @type {number}
     * @memberof HealthResponseBody
     */
    failedMessages: number;
}

/**
 * Check if a given object implements the HealthResponseBody interface.
 */
export function instanceOfHealthResponseBody(value: object): value is HealthResponseBody {
    if (!('commit' in value) || value['commit'] === undefined) return false;
    if (!('build' in value) || value['build'] === undefined) return false;
    if (!('failedMessages' in value) || value['failedMessages'] === undefined) return false;
    return true;
}

export function HealthResponseBodyFromJSON(json: any): HealthResponseBody {
    return HealthResponseBodyFromJSONTyped(json, false);
}

export function HealthResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthResponseBody {
    if (json == null) {
        return json;
    }
    return {
        
        'commit': json['commit'],
        'build': json['build'],
        'failedMessages': json['failedMessages'],
    };
}

export function HealthResponseBodyToJSON(json: any): HealthResponseBody {
    return HealthResponseBodyToJSONTyped(json, false);
}

export function HealthResponseBodyToJSONTyped(value?: HealthResponseBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'commit': value['commit'],
        'build': value['build'],
        'failedMessages': value['failedMessages'],
    };
}

